import React, { useState } from 'react';
import ModalBase from './ModalBase';
import { ApprovalStatus, Stage } from '../types';
import { useProjectDetailsContext } from '../contexts/ProjectDetailsContext';
import { useLabelContext } from '../contexts/LabelContext';

interface ReviewConfirmationModalProps {
    onClose: () => void;
    stage?: Stage;
    status?: ApprovalStatus.APPROVED | ApprovalStatus.REJECTED;
}

const ReviewConfirmationModal: React.FC<ReviewConfirmationModalProps> = ({
    onClose,
    status,
    stage,
}) => {
    const {
        handlers: { handleStageReview },
    } = useLabelContext();
    const [reason, setReason] = useState<string>('');

    return status && stage ? (
        <ModalBase
            onClose={() => {
                onClose();
                setReason('');
            }}
        >
            <div className="confirmation-modal-content">
                <h3>{stage.name}</h3>
                <p>
                    Are you sure you want to{' '}
                    <strong>
                        {status === ApprovalStatus.APPROVED
                            ? 'approve'
                            : 'reject'}
                    </strong>{' '}
                    this stage?
                </p>
                <textarea
                    placeholder={
                        status === ApprovalStatus.APPROVED
                            ? 'You can add a comment (optional)'
                            : 'If so, please add a reasoning (required)'
                    }
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                />
                <div className="button-row">
                    <button
                        className="btn-secondary"
                        onClick={() => {
                            onClose();
                            setReason('');
                        }}
                    >
                        Cancel
                    </button>
                    <button
                        className="btn-primary"
                        onClick={() => {
                            handleStageReview(
                                stage.id,
                                status,
                                !reason.trim() ? undefined : reason,
                            );
                            onClose();
                            setReason('');
                        }}
                        disabled={
                            status === ApprovalStatus.APPROVED
                                ? false
                                : !reason.trim()
                        }
                    >
                        Confirm
                    </button>
                </div>
            </div>
        </ModalBase>
    ) : null;
};

export default ReviewConfirmationModal;
